export default {
	namespaced: true,

	state: {
		isInitialized: {},

		name: null,
		type: null,

		contact: {
			to: null // uid
		},

		calendar: {
			day: null
		},

		foregetPassword: {
			otp: null
		},

		signUp: {
			otp: null
		},
		
		timeline: {
			sender: {
				admin: 'Admin'
			}
		},

		recruit: {
			hideTab: false
		},

		training: {
			hideTab: false
		}
	},

	getters: {
		get: state => state
	},

	mutations: {
		setValue (state, [key, value]) {
			state[key] = value;
		},
		setSubValue (state, [key, subKey, value]) {
			state[key][subKey] = value;
		}
	},

	actions: {
	}
}
